
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lCh01", function(module, exports) {

$parcel$export(module.exports, "SettingsComponent", () => $74b4b9cd963f315e$export$de07fd4691c461f8);

var $gwFzn = parcelRequire("gwFzn");

var $xQxzY = parcelRequire("xQxzY");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $inPa6 = parcelRequire("inPa6");

var $1HrTd = parcelRequire("1HrTd");

var $7zgzO = parcelRequire("7zgzO");

var $1NBp8 = parcelRequire("1NBp8");

var $dEBDF = parcelRequire("dEBDF");

var $7Sm4c = parcelRequire("7Sm4c");

var $dIouf = parcelRequire("dIouf");

var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");

var $a1A9A = parcelRequire("a1A9A");

var $6g41Q = parcelRequire("6g41Q");
const $74b4b9cd963f315e$var$i18n = (0, $2nPZH.defineMessages)({
    settingsName: {
        id: "app-navigation.settings.name",
        defaultMessage: "Confluence administration"
    }
});
const $74b4b9cd963f315e$export$de07fd4691c461f8 = ()=>{
    const { edition: edition, userId: userId } = (0, $bQm3c.useSessionData)();
    const { match: match, location: location } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isPremiumOnAdminCenterPage = edition === (0, $euL71.ConfluenceEdition).PREMIUM && location?.pathname === (0, $1NBp8.ADMIN_CENTER).toUrl();
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $a1A9A.OperationsQuery), {
        skip: !userId
    });
    const fireAnalytics = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'settings',
                attributes: {
                    selectedItemPageContext: match ? match.name : undefined,
                    navigationLayer: 'global',
                    navVersion: '3',
                    navdexPointType: (0, $dEBDF.START_TOUCH)
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        match
    ]);
    const handleOnClick = (0, $gwFzn.useCallback)(()=>{
        fireAnalytics();
    }, [
        fireAnalytics
    ]);
    let isSelected;
    if (typeof document !== 'undefined') isSelected = !!document.querySelector("meta[name='ajs-is-admin-page']") || isPremiumOnAdminCenterPage;
    //ts fail on AK side
    const AkSettings = (0, $1HrTd.Settings);
    if (loading) return null;
    if (error) {
        if ((0, $dIouf.isUnauthorizedError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
            error: error
        });
    }
    const isAdmin = data?.siteOperations?.application?.includes('administer');
    return isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6g41Q.EngagementInlineDialogLoaderNav3), {
        engagementId: "adminSettingsIcon",
        dataVC: "app-navigation-settings-engagement-inline-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        "data-testid": "app-navigation-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(AkSettings, {
        onClick: handleOnClick,
        href: !isPremiumOnAdminCenterPage ? (0, $1NBp8.ADMIN_SETTINGS).toUrl() : '#',
        name: "settings",
        tooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $74b4b9cd963f315e$var$i18n.settingsName),
        isSelected: isSelected
    }))) : null;
};

});
parcelRegister("1HrTd", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $6eecda670fc82d21$export$c72f6eaae7b9adff);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $14Meb = parcelRequire("14Meb");

var $8MTIk = parcelRequire("8MTIk");
const $6eecda670fc82d21$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const { component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        role: "listitem",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8MTIk.IconButton), {
            component: component,
            href: href,
            icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($14Meb))), {
                color: "currentColor",
                spacing: "spacious",
                label: typeof tooltip === 'string' ? tooltip : 'Settings Icon'
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            tooltip: tooltip,
            isTooltipAnnouncementDisabled: true,
            ...rest
        })
    });
});

});



//# sourceMappingURL=SettingsComponent.cc022aa5.js.map
